(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ActiveOnRow', [
            'MW.ContactManager.ActiveOnIcon',
            'MW.Framework.InfluencerContactService',
            'MW.ContactManager.ContactManagerPropertyTypeService'
        ])
        .directive('activeOnRow', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/active_on_row',
                scope: {
                    accounts: '=?'
                },
                controller: ActiveOnRowController,
                controllerAs: 'activeOnRowController'
            };
        })
        .controller('ActiveOnRowController', [
            '$scope',
            'activeOnTypes',
            'FairhairChannelTypes',
            ActiveOnRowController
        ]);

    function ActiveOnRowController($scope, activeOnTypes, FairhairChannelTypes) {
        this.activeOnTypes = activeOnTypes;
        this.FairhairChannelTypes = FairhairChannelTypes;
        this.accounts = this.sortSourceFirst($scope.accounts.slice());
    }

    ActiveOnRowController.prototype.sortSourceFirst = function sortSourceFirst(accounts) {
        var source;
        if (accounts && accounts.length) {
            accounts.forEach(function(account, index) {
                if (account.type === this.activeOnTypes.SOURCE || account.type === this.FairhairChannelTypes.SOURCE) {
                    source = account;
                    accounts.splice(index, 1);
                    accounts.unshift(source);
                }
            }.bind(this));
        }
        return accounts;
    };

    ActiveOnRowController.prototype.showRowForType = function showRowForType(accountType) {
        var showRow = false;
        switch(accountType) {
            case this.activeOnTypes.FACEBOOK:
            case this.activeOnTypes.TWITTER:
            case this.activeOnTypes.BLOG:
            case this.activeOnTypes.LINKED_IN:
            case this.FairhairChannelTypes.SOURCE:
            case this.activeOnTypes.SOURCE:
                showRow = true;
                break;
            default:
                break;
        }

        return showRow;
    };
}());
